export const DragDropTypes = {
  NARRATIVE_GROUP: "narrativeGroup",
  NARRATIVE_COLUMN: "narrativeColumn",
  TABLE_COLUMN: "tableColumn",
  TABLE_ROW: "tableRow"
};
